import { EVENT } from '@/constants/events'
import EventHub from '@/eventHub'
import { type PackingContainerId } from '@/constants/persoplan'

/**
 * Event when packing is finished
 */
export function emitPackingFinished(id: PackingContainerId) {
  if (!id) throw new Error('id not defined')
  EventHub.$emit(EVENT.PACKING_FINISHED, { id: id })
}
